import { DevelopmentTrackRecord, DevelopmentTrackRecordClient } from "@src/apis/ModularClient";

export class DevelopmentTrackRecordController {
  selectedSection: string;

  objects: DevelopmentTrackRecord[];
  selectedObject: DevelopmentTrackRecord;

  fetchingObjects: boolean;
  fetchingObject: boolean;

  //addingSubobject: boolean;

  //subobjects: SubobjectDTO[];
  //selectedSubobject: SubobjectDTO;

  //fetchingSubobjects: boolean;
  //fetchingSubobject: boolean;

  developmenttrackrecordForm: ng.IFormController;
  //subdevelopmenttrackrecordForm: ng.IFormController;

  static $inject = ["$routeParams", "DevelopmentTrackRecordClient"];
  //private $subobjectservice: App.Services.SubobjectService
  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private developmentTrackRecordClient: DevelopmentTrackRecordClient,
  ) {
    this.updateObjects();
  }

  updateObjects() {
    this.fetchingObjects = true;

    // Fetch all objects.
    this.developmentTrackRecordClient
      .list()
      .then((response) => {
        this.objects = response;
        this.preSelectedItem();
      })
      .finally(() => {
        this.fetchingObjects = false;
      });
  }

  private preSelectedItem() {
    if (this.$routeParams.Id) {
      let selectedObject = this.objects.find((value, index) => {
        return value.id === parseInt(this.$routeParams.objectId);
      });

      this.selectObject(selectedObject);
    }
  }

  selectObject(object: DevelopmentTrackRecord) {
    this.selectedObject = object;

    //this.fetchingSubobjects = true;
    //this.$subobjectservice.fetchSubobjectsForObject(object.Id).then((response) => {
    //    this.subobjects = response;
    //    this.fetchingSubobjects = false;
    //}).catch((response) => {
    //    this.fetchingSubobjects = false;
    //});

    this.selectedSection = "details";
  }

  createObject() {
    this.selectedSection = "details";
    this.selectedObject = {} as DevelopmentTrackRecord;
  }

  save() {
    this.developmentTrackRecordClient.addUpdateReturnOnlyID(this.selectedObject).then((response) => {
      this.selectedObject.id = response;
      if (!this.objects) {
        this.objects = [];
      }

      let matches: DevelopmentTrackRecord[] = this.objects.filter((value, index) => {
        return value.id == response;
      });

      if (!matches || matches.length === 0) {
        this.objects.push(this.selectedObject);
      }

      this.developmenttrackrecordForm.$setPristine();
      this.updateObjects();
    });
  }

  delete() {
    this.developmentTrackRecordClient.markAsDeleted(this.selectedObject.id).then((response) => {
      if (response) {
        this.objects.splice(this.objects.indexOf(this.selectedObject), 1);
        this.developmenttrackrecordForm.$setPristine();
        delete this.selectedObject;
      }
    });
  }

  //addSubobject() {
  //    this.selectedSubobject = {
  //        AssociatedObjectId: this.selectedObject.Id,
  //        AssociatedObjectName: this.selectedObject.Name
  //    } as SubobjectDTO;
  //}

  //removeSubobject(subobject: SubobjectDTO) {
  //    this.$subobjectservice.deleteSubobject(subobject.Id).then((response) => {
  //        this.subobjects.splice(this.subobjects.indexOf(this.selectedSubobject), 1);
  //        delete this.selectedSubobject;
  //    });
  //}

  //cancelUpdateSubobject() {
  //    delete this.selectedSubobject;
  //}

  //updateSubobject(subobject: SubobjectDTO) {
  //    this.$subobjectservice.addUpdateSubobject(subobject).then((response) => {
  //        if (this.subobjects.indexOf(subobject) === -1) {
  //            this.subobjects.push(subobject);
  //        }
  //        delete this.selectedSubobject;
  //    }).catch((response) => {
  //        delete this.selectedSubobject;
  //    });

  //}
}
